import React from "react"
import autobind from "class-autobind"
import { FloatingActionButton, CircularProgress, Drawer } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import { INoteDocument, INoteSearchParam, INoteSearch, IDateRange, ITimecardDay, INoteObjectData } from "../../../models"
import strings from "../../../localization/strings"
import moment from "moment"
import * as api from "../../../api"
import AccountStore from "../../../stores/AccountStore"
import AddNewNote from "../../Notes/AddNewNote"
import NotesList from "../../Notes/NotesList"

interface IProps {
    timecardNoteObjectData: INoteObjectData
    timecardDates: IDateRange
    dayData: ITimecardDay
    dataType: string
}
interface IState {
    loading: boolean
    notes: INoteDocument[]
    openAddNoteDrawer: boolean
}

export default class NoteDrawerContent extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            loading: false,
            notes: [],
            openAddNoteDrawer: false
        }
        autobind(this)
    }

    componentDidMount() {
        (this.props.timecardNoteObjectData.ObjectId || (this.props.timecardNoteObjectData.TimecardRef && this.props.timecardNoteObjectData.TimecardRef.UserId)) &&
            this.getNotes()
    }

    getNotes() {
        this.setState({ loading: true }, () => {
            const notesPayload = {
                AccountId: AccountStore.getCurrentAccount().Id,
                ObjectId: this.props.timecardNoteObjectData.ObjectId,
                Audits: false,
                ReferenceDataRange: this.props.timecardDates,
                NoteTimecardRef: this.props.timecardNoteObjectData.TimecardRef
            } as INoteSearchParam
            api.getNotes(notesPayload).then(res => {
                const data = res.data as INoteSearch
                this.setState({
                    loading: false,
                    notes: data.Documents
                })
            })
        })
    }

    render() {
        const dayNotes = this.state.notes.filter(i => moment(this.props.dayData.LocalStartDayTime).isSameOrBefore(i.ReferenceDate) && moment(i.ReferenceDate).isSameOrBefore(this.props.dayData.LocalEndDayTime))
        return (
            <div style={{ textAlign: "center", paddingLeft: 20, paddingRight: 20, paddingTop: 35 }}>
                <FloatingActionButton data-intercom-target={"Btn-Add-Note"} className="fixed-add" style={{ top: -30, right: 40, zIndex: 998 }} secondary={true} onTouchTap={() => this.setState({ openAddNoteDrawer: true })}>
                    <ContentAdd />
                </FloatingActionButton>
                {this.state.loading ?
                    <div className="spinner">
                        <CircularProgress />
                    </div> :
                    dayNotes.length === 0 ?
                        <h2 style={{ textAlign: "center", marginTop: 25 }}>
                            {strings.No_Note}
                        </h2> :
                        <NotesList
                            simpleList={false}
                            notes={dayNotes}
                        />
                }
                {this.state.openAddNoteDrawer &&
                    <Drawer
                        open={this.state.openAddNoteDrawer}
                        width={1000}
                        style={{ maxWidth: 1000 }}
                        openSecondary
                        docked={false}
                        overlayStyle={{ zIndex: 1500 }}
                        containerStyle={{
                            zIndex: 1500,
                            opacity: open ? 1 : 0,
                            transition: "opacity 200ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms"
                        }}
                        onRequestChange={() => this.setState({ openAddNoteDrawer: false })}
                    >
                        <AddNewNote
                            objectData={this.props.timecardNoteObjectData}
                            objectName={"timecard"}
                            noteReferenceDate={this.props.dayData.LocalStartDayTime}
                            getNotes={this.getNotes}
                            closeDrawer={() => this.setState({ openAddNoteDrawer: false })}
                            dataType={this.props.dataType}
                        />
                    </Drawer>
                }
            </div>
        )
    }
}